import { SaleDetailModel } from 'api-hooks/sale/model';
import { PreferenceFormSchema } from 'common/form-schema';
import * as Yup from 'yup';

export const HotelRescheduleDetailAddOnsFormSchema = () =>
  Yup.object({
    isSelected: Yup.boolean().default(false),
    id: Yup.string().default(''),
    guestId: Yup.string().default(''),
    description: Yup.string().default(''),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    priceUnit: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    unit: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //additional information
    guestName: Yup.string().default(''),
    customId: Yup.string().default(''),
  });

export const HotelRescheduleDetailHotelFormSchema = () =>
  Yup.object({
    checkIn: Yup.date().nullable().default(null),
    checkOut: Yup.date().nullable().default(null),
    detail: Yup.string().default(''),
    checkInStatus: Yup.string().nullable().default(null),
    hotelConfirmationCode: Yup.string().default(''),
    id: Yup.string().default(''),
    hotelRoomId: Yup.string().default(''),
    night: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    room: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    price: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),
    pax: Yup.number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .default(0),

    //additional information
    hotelRoomName: Yup.string().default(''),
    customId: Yup.string().default(''),
  });

export const HotelRescheduleDetailGuestFormSchema = () =>
  Yup.object({
    isLead: Yup.boolean().default(false),
    preferences: Yup.array(PreferenceFormSchema()).default([]),
    id: Yup.string().default(''),
    guestId: Yup.string().default(''),

    //additional information
    guestName: Yup.string().default(''),
    customId: Yup.string().default(''),
  });

export const HotelRescheduleDetailFormSchema = () =>
  Yup.object({
    isSelected: Yup.boolean().default(false),
    id: Yup.string().default(''),
    hotelId: Yup.string().default(''),
    bookingCode: Yup.string().default(''),
    isCityTax: Yup.boolean().default(false),
    isByPax: Yup.boolean().default(false),
    cityTax: Yup.string().default(''),
    hotelSaleGuests: Yup.array(HotelRescheduleDetailGuestFormSchema()).default(
      [],
    ),
    hotelSaleAddOns: Yup.array(HotelRescheduleDetailAddOnsFormSchema()).default(
      [],
    ),
    hotelSaleHotels: Yup.array(HotelRescheduleDetailHotelFormSchema()).default(
      [],
    ),

    originalHotelSaleHotels: Yup.array(
      HotelRescheduleDetailHotelFormSchema(),
    ).default([]),

    //additional information
    hotelName: Yup.string().default(''),
    customId: Yup.string().default(''),
  });

export const HotelRescheduleFormSchema = () =>
  Yup.object({
    transactionAt: Yup.date().default(new Date()),
    tempTransactionAt: Yup.date().default(new Date()),
    total: Yup.number().default(0),
    hotelSales: Yup.array(HotelRescheduleDetailFormSchema()).default([]),
  });

export type HotelRescheduleFormType = Yup.InferType<
  ReturnType<typeof HotelRescheduleFormSchema>
> & {
  hotelSale: SaleDetailModel;
};

export type HotelRescheduleDetailFormType = Yup.InferType<
  ReturnType<typeof HotelRescheduleDetailFormSchema>
>;

export type HotelRescheduleDetailGuestFormType = Yup.InferType<
  ReturnType<typeof HotelRescheduleDetailGuestFormSchema>
>;

export type HotelRescheduleDetailAddOnsFormType = Yup.InferType<
  ReturnType<typeof HotelRescheduleDetailAddOnsFormSchema>
>;

export type HotelRescheduleDetailHotelFormType = Yup.InferType<
  ReturnType<typeof HotelRescheduleDetailHotelFormSchema>
>;
